import { DIETARY_ATTRIBUTES } from '../../../../views/phone-answering/constants';

export default {
  [DIETARY_ATTRIBUTES.DAIRY_FREE]: 'Dairy free',
  [DIETARY_ATTRIBUTES.HALAL]: 'Halal',
  [DIETARY_ATTRIBUTES.SPICY]: 'Spicy',
  [DIETARY_ATTRIBUTES.VEGAN]: 'Vegan',
  [DIETARY_ATTRIBUTES.GLUTEN_FREE]: 'Gluten free',
  [DIETARY_ATTRIBUTES.VEGETARIAN]: 'Vegetarian',
};
